<template lang="pug">
  div(
    :class="$style.wrapper"
    id="search-wrapper-desktop")
    div(:class="$style.theHeader" :style="theHeaderStyle")
      div(:class="$style.bigSearch")
        Txt(
          placeholder="Start typing to find your items"
          v-model="searchFor"
          ref="searchFor"
          id="searchFor"
          @focus="focusItem"
          @input="searchItem(searchFor)"
          :class="{[$style.hasResults]: searchFor !== null}"
          :icon-left="'i:search-find'"
          :icon-size="24"
          icon-color="#41a5dd"
          autocomplete="one-time-code"
          qa-tag="item-search-inp")
        button(
          v-if="searchFor"
          :class="$style.searchClear"
          @click.stop="clearSearch") clear
      .close-button(@click.stop="closeSearch" :style="closeButtonStyle")
        Icon.text-gray-800(
          name="i:close-1-1"
          :size="20")
    div(ref="dropdownBox" :class="$style.dropdownBox" :style="dropdownBoxStyle")
      div(ref="dropdown" :class="$style.dropdown")
        p(:class="[$style.categoryTitle, 'fade-in']") Frequently Added
        div(:class="{[$style.categoryMenu]: true, 'fade-in': true, 'sliding': !search_getIsExtraLarge, 'right-side': !showLeftSideOfCategoryMenu}")
          template(v-if="search_getIsExtraLarge")
            div(
              key="popular"
              :class="{'menu-item': true, 'active': isPopularItemsActive}"
              @click="openPromoCategory")
              p Popular
            template(
              v-for="(itemCategory, index) in itemCategories")
              div(
                v-if="FURNITURE_DEFAULT_INVENTORY_DESKTOP[itemCategory.item_tag_id]"
                :key="`${index}`"
                :class="{'menu-item': true, 'active': openSection && openSection.details.item_tag_id == itemCategory.item_tag_id}"
                @click="openItemCategory(itemCategory)")
                p {{FURNITURE_DEFAULT_INVENTORY_DESKTOP[itemCategory.item_tag_id].label}}
          template(v-else)
              .menu-column
                div(
                  key="popular"
                  :class="{'menu-item': true, 'active': isPopularItemsActive}"
                  @click="openPromoCategory")
                  p Popular
                template(
                  v-for="(itemCategory, index) in itemCategories")
                  div(
                    v-if="FURNITURE_DEFAULT_INVENTORY_LEFT_DESKTOP[itemCategory.item_tag_id]"
                    :key="`${index}`"
                    :class="{'menu-item': true, 'active': openSection && openSection.details.item_tag_id == itemCategory.item_tag_id}"
                    @click="openItemCategory(itemCategory)")
                    p {{FURNITURE_DEFAULT_INVENTORY_DESKTOP[itemCategory.item_tag_id].label}}
                div(
                  key="<"
                  class="menu-item icon icon-right"
                  @click="showLeftSideOfCategoryMenu = false; $snowplow.trackIOLPDesktopMenuRight(search_getItemsCount)")
                  Icon(
                    name="i:chevron-right-rounded"
                    :size="16")
              .menu-column
                div(
                  key=">"
                  class="menu-item icon icon-left"
                  @click="showLeftSideOfCategoryMenu = true; $snowplow.trackIOLPDesktopMenuLeft(search_getItemsCount)")
                  Icon(
                    name="i:chevron-left-rounded"
                    :size="16")
                template(
                  v-for="(itemCategory, index) in itemCategories")
                  div(
                    v-if="FURNITURE_DEFAULT_INVENTORY_RIGHT_DESKTOP[itemCategory.item_tag_id]"
                    :key="`${index}`"
                    :class="{'menu-item': true, 'active': openSection && openSection.details.item_tag_id == itemCategory.item_tag_id}"
                    @click="openItemCategory(itemCategory)")
                    p {{FURNITURE_DEFAULT_INVENTORY_DESKTOP[itemCategory.item_tag_id].label}}

        div(:class="{[$style.content]: true, 'fade-in': true, [$style.scrollRequired]: scrollRequired}")
          div(
            v-if="openSection && openSection.name"
            :class="$style.categoryResult")
            MoveItemsDesktop(
              :label="FURNITURE_DEFAULT_INVENTORY_DESKTOP[openSection.details.item_tag_id].label"
              :title="FURNITURE_DEFAULT_INVENTORY_DESKTOP[openSection.details.item_tag_id].title"
              :items="getItems(openSection.details)")
          div(
            v-else
            :class="$style.searchResult")
            template(v-if="searchFor === ''")
              ItemRows(
                :items="category_getItemsWithCustomItem(categoryPromo)"
                :category="categoryPromo"
                source="popular_item")
            template(v-else-if="searchFor.length < searchLimit")
              div Please continue typing to see results
            template(v-else)
              .mt-ds-md.text-sm.text-black50.font-bold(v-if="search_getItems(searchFor).length") Suggested Items
              ItemRows(
                :items="search_getItems(searchFor)"
                :search="searchFor"
                source="search_item")
              .text-sm.text-black50.font-bold Custom Item
              div(
                :class="$style.customItem"
                @click="$emitter.emit('open-create-item', {'name': searchFor, 'source': 'search_results'})")
                | {{searchFor}}
                div
                  | (enter dimensions)
                button Add
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import {
  DESKTOP_DROPDOWN_MAX_HEIGHT,
  DESKTOP_SEARCH_ITEMS_COUNT_TO_VIEW,
  FURNITURE_DEFAULT_INVENTORY_DESKTOP,
  FURNITURE_DEFAULT_INVENTORY_LEFT_DESKTOP,
  FURNITURE_DEFAULT_INVENTORY_RIGHT_DESKTOP,
  FURNITURE_OTHER_TYPE_DESKTOP,
  ITEM_CATEGORY_PROMO_DESKTOP,
  ITEM_SEARCH_LIMIT
} from "~/constants/item"
import { GET_ITEMS, SEARCH_ITEMS } from "~/store/item-search"
import { CATEGORY_ITEMS, GET_ITEMS_WITH_CUSTOM_ITEM } from "~/store/item-category"
import { CATEGORY_V4_ID_FURNITURE } from "~/constants/category"
import { GET_ITEMS_COUNT } from "~/store/listing"
import { GET_IS_EXTRA_LARGE } from "~/store/pages"
import MoveItemsDesktop from "~/components/parts/MoveItemsDesktop.vue"

export default defineComponent({
  name: "MoveSearchDesktop",
  components: {
    MoveItemsDesktop /* Only 1 component can be eager loaded */
    // ItemRows /* Cannot be eager loaded so have a workaround at watch */
  } /* Eager load components to fix watch itemsCount height detection bug on generation */,

  props: {
    itemCategories: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      categoryPromo: ITEM_CATEGORY_PROMO_DESKTOP.key,
      searchFor: "",
      searchLimit: ITEM_SEARCH_LIMIT,
      timeout: null as null | NodeJS.Timeout,
      openSection: {
        name: null as string | null,
        details: {} as Record<string, any>
      },
      showLeftSideOfCategoryMenu: true,
      theHeaderStyle: "",
      closeButtonStyle: "",
      dropdownBoxStyle: ""
    }
  },

  computed: {
    ...mapGetters("item-category", {
      category_getItems: GET_ITEMS,
      category_getItemsWithCustomItem: GET_ITEMS_WITH_CUSTOM_ITEM
    }),
    ...mapGetters("item-search", {
      search_getItems: GET_ITEMS
    }),
    ...mapGetters("listing", {
      search_getItemsCount: GET_ITEMS_COUNT
    }),
    ...mapGetters("pages", {
      search_getIsExtraLarge: GET_IS_EXTRA_LARGE
    }),
    isPopularItemsActive(): boolean {
      return this.searchFor === "" && (!this.openSection || !this.openSection.name)
    },
    itemsCount(): number {
      return this.openSection && this.openSection.name
        ? this.getItems(this.openSection.details).length
        : this.searchFor === ""
          ? this.category_getItemsWithCustomItem(this.categoryPromo).length
          : this.search_getItems(this.searchFor).length + 3
    },
    scrollRequired(): boolean {
      return this.itemsCount > DESKTOP_SEARCH_ITEMS_COUNT_TO_VIEW
    },
    FURNITURE_DEFAULT_INVENTORY_DESKTOP() {
      return FURNITURE_DEFAULT_INVENTORY_DESKTOP
    },
    FURNITURE_DEFAULT_INVENTORY_LEFT_DESKTOP() {
      return FURNITURE_DEFAULT_INVENTORY_LEFT_DESKTOP
    },
    FURNITURE_DEFAULT_INVENTORY_RIGHT_DESKTOP() {
      return FURNITURE_DEFAULT_INVENTORY_RIGHT_DESKTOP
    }
  },

  watch: {
    itemsCount(newValue, oldValue) {
      if (this.isPopularItemsActive) {
        /* Cannot eager load ItemRows, so this workaround is required */
        this.dropdownBoxStyle = `height:${DESKTOP_DROPDOWN_MAX_HEIGHT}px;`
      } else {
        this.$nextTick(() => {
          // @ts-ignore - Property 'offsetHeight' does not exist
          const dropdownHeight = this.$refs.dropdown.offsetHeight
          this.dropdownBoxStyle = `min-height:185px; height:${dropdownHeight - 8}px;`
        })
      }
    }
  },

  created() {
    this.$store.dispatch("item-category/" + CATEGORY_ITEMS, ITEM_CATEGORY_PROMO_DESKTOP)
  },

  beforeMount() {
    this.$emitter.on("close-dropdown", this.emptyStyles)
  },

  mounted() {
    if (this.$refs.searchFor) {
      // @ts-ignore: ref="searchFor" should be added to the search input
      this.$refs.searchFor.focus()
    }
    this.theHeaderStyle = "border-bottom-color:#f0f0f0;"
    this.closeButtonStyle = "opacity:1; margin-right:0;"
    this.dropdownBoxStyle = `height:${DESKTOP_DROPDOWN_MAX_HEIGHT}px;`
  },

  methods: {
    focusItem() {
      this.$emit("open-search", true)
    },
    searchItem(pattern) {
      this.$emit("open-search", true)

      this.openSection.name = null
      this.openSection.details = {}

      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.timeout = setTimeout(async () => {
        if (!this.search_getItems(pattern).length) {
          const searchParams = {
            name: pattern,
            category_id: CATEGORY_V4_ID_FURNITURE
          }
          const payload = {
            $axios: this.$axios,
            $config: this.$config.public,
            searchParams,
            locale: this.$i18n.locale
          }
          const resultCount = await this.$store.dispatch("item-search/" + SEARCH_ITEMS, payload)
          if (searchParams.name.length >= ITEM_SEARCH_LIMIT) {
            this.$snowplow.trackSearchItem(searchParams.name, resultCount)
          }
        }
      }, 200)
    },
    emptyStyles() {
      this.theHeaderStyle = ""
      // override fade-in transition opacity 1.5s
      this.closeButtonStyle = "transition: opacity 0.5s, margin-right 0.5s;"
      this.dropdownBoxStyle = ""
    },
    closeSearch() {
      this.emptyStyles()
      this.$emit("open-search", false)
      this.$emit("close")
      this.$snowplow.trackIOLPDesktopClose(this.search_getItemsCount)
    },
    clearSearch() {
      this.$snowplow.trackSearchClear(this.searchFor)
      this.searchFor = ""
      // @ts-ignore: ref="searchFor" should be added to the search input
      this.$refs.searchFor.focus()
    },
    openItemCategory(itemCategory) {
      this.searchFor = ""
      // Setting the openSection empty first to enforce that the new category (should be in nextTick) items are loaded
      this.openSection.name = null
      this.openSection.details = {}
      this.$nextTick(() => {
        this.openSection.name = "category"
        this.openSection.details = itemCategory
        this.$snowplow.trackCategoryButton(
          FURNITURE_DEFAULT_INVENTORY_DESKTOP[itemCategory.item_tag_id].title,
          this.search_getItemsCount,
          "click",
          FURNITURE_DEFAULT_INVENTORY_DESKTOP[itemCategory.item_tag_id].label
        )
      })
    },
    openPromoCategory() {
      this.openSection.name = null
      this.openSection.details = {}
      this.searchFor = ""
      this.$snowplow.trackCategoryButton(
        ITEM_CATEGORY_PROMO_DESKTOP.key,
        this.search_getItemsCount,
        "click",
        ITEM_CATEGORY_PROMO_DESKTOP.key
      )
    },
    getItems(itemCategory): Item[] {
      const items = Object.assign({}, itemCategory.items)
      const result: Item[] = Object.values(items)
      // Without using cloning we run into error: [vuex] do not mutate vuex store state outside mutation handlers
      result.push(Object.assign({}, FURNITURE_OTHER_TYPE_DESKTOP))
      return result
    }
  }
})
</script>

<style lang="css" module>
@import "~/assets/scss/iolp.scss";

@screen lg {
  .theHeader {
    @apply flex justify-between mb-ds-sm pt-ds-xxs pb-ds-xxxs pl-0 border-b border-b-transparent;
    transition: border-bottom-color 0.5s;

    & :global(.close-button) {
      @apply opacity-0 -mr-[40px];
      /* opacity 1.5 behaves like it is 0.5s */
      transition:
        opacity 1.5s,
        margin-right 0.5s;
    }
  }

  .dropdownBox {
    @apply w-full h-0 relative overflow-hidden;
    transition: height 0.3s;
  }

  .dropdown {
    @apply w-full absolute -top-ds-sm;

    & > :global(.fade-in) {
      &:nth-child(1),
      &:nth-child(2) {
        /* 0.2 delay, 0.4 transition */
        animation: fade-in 0.6s ease-out;
      }

      &:nth-child(3) {
        /* 0.4 delay, 0.4 transition */
        animation: fade-in-later 0.8s ease-out;
      }
    }
  }

  .bigSearch {
    @apply relative grid h-full w-full pr-ds-sm;
    display: grid;
    grid-template-rows: min-content auto;

    & > div {
      @apply w-full;
    }

    :global(.text-input) input {
      @apply p-ds-md leading-2xl h-ds-xl text-lg border-none;
    }
  }

  .searchClear {
    @apply absolute h-[40px] top-ds-xxs right-ds-md px-ds-sm bg-white font-bold text-sm text-anyvan-yellow-dark rounded-3xl;
  }

  .categoryTitle {
    @apply pl-ds-md pt-ds-md text-black50 text-sm font-bold leading-normal;
  }

  .categoryMenu {
    @apply flex gap-x-ds-sm px-ds-md pt-ds-sm pb-ds-md font-bold;

    &:global(.sliding) {
      @apply w-[200%] gap-x-ds-lg;
      transition: transform 0.5s;

      &:global(.right-side) {
        transform: translateX(-50%);
      }

      & :global(.menu-column) {
        @apply w-full flex gap-x-ds-sm;
      }
    }

    & :global(.menu-item) {
      @apply flex-1 px-[17px] py-ds-sm border-2 border-transparent rounded-lg bg-gray-140 text-center cursor-pointer;

      &:hover {
        @apply bg-gray-250;
      }

      &:global(.active) {
        @apply border-black50;
      }

      &:global(.icon) {
        @apply max-w-fit leading-none;
      }

      & > p {
        @apply text-sm leading-normal;
      }
    }
  }

  .searchResult,
  .categoryResult {
    @apply w-full px-ds-md pt-0 pb-ds-md leading-normal flex flex-col gap-ds-sm;

    & > p {
      @apply text-black70 leading-normal pb-ds-sm select-none;
    }

    li {
      @apply px-ds-md py-0 rounded-md;
    }

    strong {
      @apply text-black70;
    }
  }

  .customItem {
    @apply flex px-ds-md py-ds-sm rounded-md font-bold leading-normal cursor-pointer;

    &:hover {
      @apply bg-gray-140;
    }

    div {
      @apply flex-1 pl-ds-xxs text-blue-primary;
    }

    button {
      @apply h-ds-ml w-[80px] text-sm text-white bg-blue-primary rounded-[100px];
    }
  }

  :global {
    /* To prevent auto-zoom in Safari */
    .safari #searchFor {
      font-size: 16px;
    }
  }
}

@media (min-width: 1200px) and (max-width: 1511px) {
  .categoryMenu {
    & :global(.menu-item) {
      @apply px-ds-sm;
    }
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  33% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-in-later {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
